import mixins from 'synergycms_core/src/less/mixins';

export default {
  valid: {},
  invalid: {},
  defaultStyle: {
    '&$valid': {
      '&:before': {
        content: "'\\e046'",
        position: 'absolute',
        right: '20px',
        top: '50%',
        font: '15px/1px Icons',
        marginTop:'-5px',
        color: data => data.secondColor,
        width: '15px',
        textAlign: 'center',
        ...mixins.transition(),
      },
      '&:lang(ar)':{
        '&:before': {
          left: '20px',
          right: 'auto',
        }
      }
    },
    '&$invalid': {
      content: "'\\e046'",
      fontSize: '12px',
      color: '#d0021b',
      marginTop: '4px',
      display: 'block',
      marginLeft: '16px',
      '&:lang(ar)':{
        '&:before':{
          marginRight:'16px',
          marginLeft: 0
        }
      }
    },
  }
};
